
$_GP.ajaxCaptchaRequest = function(elm,url,argOpt) {
	elm = $(elm);
	if (!elm.length) return

	argOpt = argOpt || {}
	const dataOpt = elm.data('opt') || {}

	const opt = $.extend({}, dataOpt, argOpt)

	const ajax = $_GP.ajax(url, opt.sendData, 'html', 'POST');

	ajax.done(function (resp) {
		if (resp) {
			elm.removeClass('d-n');
			elm.find('input').removeAttr('disabled');
			elm.find('img').attr('src', $(resp).attr('src'));
		} else {
			elm.addClass('d-n');
			elm.find('input').attr('disabled', 'disabled');
		}
	});

	return ajax
}

$_GP.ajaxCaptcha = function(url) {
	const container = $('[data-captcha="container"]')
	if (!container.length) return

	let captchas = {}

	container.find('[data-captcha="trigger"]').on('click', function(ev) {
		$_GP.ajaxCaptchaRequest($(this).closest('[data-captcha="container"]'),url)
	});

	container.each((i,elm)=> {
		elm = $(elm)
		captchas[elm.data('opt').name] = {}
		const ajax = $_GP.ajaxCaptchaRequest(elm,url)
		captchas[elm.data('opt').name].elm = elm
		captchas[elm.data('opt').name].ajax = ajax
	})

	return captchas
};
